(() => {
  const hub = document.querySelector('[data-ff-help-hub]');
  if (!hub) return;

  const push = (eventName, detail = {}) => {
    const payload = {
      locale: (document.documentElement.lang || 'nl').toLowerCase().split('-')[0],
      ...detail,
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
    try {
      const published = window.Shopify?.analytics?.publish?.(`fashfresh:${eventName}`, payload);
      if (published?.catch) published.catch(() => {});
    } catch (_) {
      // Metingen mogen de washulp nooit blokkeren.
    }
  };

  push('ff_help_hub_view', { tools_shown: 7 });

  hub.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ff-help-link]');
    if (!link) return;
    push('ff_help_hub_tool_click', {
      tool: link.dataset.ffHelpLink,
      placement: link.dataset.ffHelpPlacement || 'unknown',
      destination: new URL(link.href, window.location.href).pathname,
    });
  });
})();
